module.exports = __webpack_public_path__ + "assets/media/share.94f57cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/share.png
// module id = 3239
// module chunks = 0